import { useState, useEffect, useRef, useCallback } from 'react'

import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import Portal from '@jimmyboys/liita-ui/dist/components/Portal'

import styles from './LightBoxButton.module.sass'

const LightBoxButton = (props) => {
	const { isDisabled, total, icon, children } = props

	const mountPoint = document.getElementById('lightbox-container')

	const buttonRef = useRef(null)
	const dragRef = useRef({ isDragging: false, startX: 0, startY: 0, initX: 0, initY: 0 })
	const [lightBoxPos, setLightBoxPos] = useState({ top: 0, left: 0 })
	const [showLightBox, setShowLightBox] = useState(false)
	const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 })

	useEffect(() => {
		const element = buttonRef?.current
		if (!element) return

		const buttonPosition = element.getBoundingClientRect()

		setLightBoxPos({
			top: buttonPosition.bottom,
			left: buttonPosition.left,
		})
	}, [])

	const handleDragStart = useCallback((e) => {
		if (e.button !== 0) return
		if (e.target.closest('button, input, select, textarea, a')) return
		e.preventDefault()
		const ref = dragRef.current
		ref.isDragging = true
		ref.startX = e.clientX
		ref.startY = e.clientY
		ref.initX = dragOffset.x
		ref.initY = dragOffset.y
		const onMove = (e) => {
			if (!ref.isDragging) return
			setDragOffset({ x: ref.initX + (e.clientX - ref.startX), y: ref.initY + (e.clientY - ref.startY) })
		}
		const onUp = () => {
			ref.isDragging = false
			ref.initX = ref.initX + (e.clientX - ref.startX)
			ref.initY = ref.initY + (e.clientY - ref.startY)
			document.removeEventListener('mousemove', onMove)
			document.removeEventListener('mouseup', onUp)
		}
		document.addEventListener('mousemove', onMove)
		document.addEventListener('mouseup', onUp)
	}, [dragOffset.x, dragOffset.y])

	useEffect(() => {
		if (showLightBox) {
			setDragOffset({ x: 0, y: 0 })
		}
	}, [showLightBox])

	const menuStyle = {
		'--lightbox-left': `${lightBoxPos.left || 0}px`,
		'--lightbox-top': `${lightBoxPos.top || 0}px`,
		transform: `translate(${dragOffset.x}px, ${dragOffset.y}px)`,
	}

	return (
		<div ref={buttonRef}>
			<ActionButton
				className={`${styles['icon-container']} ${
					isDisabled ? styles['--disabled'] : ''
				}`}
				disabled={isDisabled}
				onClick={() => setShowLightBox(true)}
			>
				<Icon name={icon} height='20px' width='20px' />
				{!isDisabled && total > 0 && (
					<small className={styles['filter-counter']}>
						{total > 9 ? '+9' : total}
					</small>
				)}
			</ActionButton>
			{showLightBox && (
				<Portal id={'lightbox-container'} ref={mountPoint}>
					<div
						className={styles['menu-backdrop']}
						onClick={() => setShowLightBox(false)}
					/>
					<div
						className={styles['menu']}
						style={menuStyle}
					>
						<div style={{ cursor: 'move', padding: '0 0 4px 0', borderBottom: '1px solid #eee', marginBottom: '4px', userSelect: 'none' }} onMouseDown={handleDragStart}>
							<Icon name='dock-window' width='14px' height='14px' />
						</div>
						{children}
					</div>
				</Portal>
			)}
		</div>
	)
}

export default LightBoxButton
